import { setLocations } from "../../state/ducks";
import { selectLocations } from "../../state/selectors";
import { dispatch, getState } from "../../state/store";

import httpClient from "../httpClient";
import { locationApi } from "./config";

const apiUrl = process.env.REACT_APP_API_URL;

const getLocationManagement = async (method, market) => {
  const url = `${apiUrl}/location-management/${method}?market=${market}`;

  return await httpClient.get(url);
};

const postLocationManagement = async (request, method, body) => {
  const url = `${apiUrl}/location-management/${method}`;

  return await httpClient[request](url, { data: body });
};

const fetchLocations = async (market) => {
  const data = await getLocationManagement(locationApi.GET_LOCATIONS, market);

  if (data?.data) {
    dispatch(setLocations({ market, locations: data.data }));
  }

  return data?.data;
};

const createNewLocation = async (newLocation) => {
  const res = await postLocationManagement("post", locationApi.CREATE_LOCATION, newLocation);

  await fetchLocations(newLocation?.market);

  return res;
};

const deleteLocation = async (market, id) => {
  const res = await postLocationManagement("remove", locationApi.DELETE_LOCATION, { market, id });
  await fetchLocations(market);

  return res;
};

const updateLocation = async (location) => {
  const res = await postLocationManagement("put", locationApi.UPDATE_LOCATION, location);
  await fetchLocations(location?.market);

  return res;
};

//todo:
const getLocationOptions = (market) => {
  const locationsByMarket = selectLocations(market)(getState());
  let locations = [];

  if (locationsByMarket && locationsByMarket?.length > 0) {
    locations = locationsByMarket.map((location) => {
      return { id: location?.id, value: location?.name, city: location?.city };
    });
  }

  return locations;
};

const locationsService = {
  fetchLocations,
  createNewLocation,
  updateLocation,
  deleteLocation,

  getLocationOptions
};

export default locationsService;
